import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import CustomerForm from '../../components/CustomerForm';

const CustomerEditPage = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get customer ID from URL

  return (
    <Layout pageTitle="Edit Customer">
      <div className="max-w-4xl mx-auto p-6 bg-gray-50 min-h-screen">
        <h1 className="text-2xl font-bold mb-6">Edit Customer</h1>

        <div className="bg-white rounded-lg shadow-md p-6">
          <CustomerForm
            customerId={id} // Pass ID to fetch existing customer
            onSaved={() => navigate('/customer')}
            onCancel={() => navigate('/customer')}
          />
        </div>
      </div>
    </Layout>
  );
};

export default CustomerEditPage;
